export default "__VITE_ASSET__ToC5eqkV__"